import defaultBackground from './assets/default-background.png';
import defaultOverlay from './assets/default-overlay.png';

export const DEVICE_PRESETS = [
  {
    id: 'iphone',
    label: 'iPhone',
    width: 390,
    height: 844,
  },
  {
    id: 'tablet',
    label: 'Tablet',
    width: 768,
    height: 1024,
  },
  {
    id: 'desktop',
    label: 'Desktop',
    width: 1024,
    height: 768,
  },
  {
    id: 'wide',
    label: 'Wide',
    width: 1920,
    height: 1080,
  },
  {
    id: 'custom',
    label: 'Custom',
    width: 390,
    height: 844,
  },
];

export const DEFAULT_PRESET_ID = 'multi';

/** Presets shown together in Multi View (phone left, landscapes stacked right). */
export const MULTI_VIEW_PRESETS = DEVICE_PRESETS.filter((preset) => (
  preset.id === 'iphone' || preset.id === 'desktop' || preset.id === 'wide'
));

export { defaultBackground, defaultOverlay };

export const createDefaultConfig = () => ({
  backgroundImageUrl: defaultBackground,
  overlay: 'image',
  text: 'try something new',
  overlayImageUrl: defaultOverlay,
  logoColor: '#ffffff',
  showAnnouncementBanner: true,
  primaryButton: {
    enabled: true,
    label: 'Shop Beer',
  },
  secondaryButton: {
    enabled: true,
    label: 'Find Us',
  },
});
